'use strict';
const options_collection = {
  collectionsLoadMore: '.collections-load-more',
  rangeSlider: '.price-range .range-slider',
  rangeSliderMin: '.range-slider-min',
  rangeSliderMax: '.range-slider-max',
  minPriceRange: '.min-price-range',
  maxPriceRange: '.max-price-range',
  collectionSidebar: '#CollectionSidebar',
  collectionFilterBlocks: '.filter-blocks',
  productgridcontainer: '#productgridcontainer',
  collectionFiltersForm: '#CollectionFiltersForm',
  section: '.sec__collection-main',
};

class BtnFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById('CollectionSidebar');
    this.setAttribute('role', 'button');
    this.setAttribute('tabindex', '0');
    this.setAttribute('aria-controls', 'CollectionSidebar');
    this.setAttribute('aria-expanded', 'false');
    this.addEventListener('click', this.onOpen.bind(this), false);
    this.addEventListener('keydown', this.onKeyDown.bind(this), false);
    this.onDrawerKeyDown = this.handleDrawerKeyDown.bind(this);
    this.onViewportChange = () => this.syncAccessibilityState();
    window.addEventListener('resize', this.onViewportChange);
    this.syncAccessibilityState();
  }
  onKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onOpen();
    } else if (event.key === 'Escape' && this.classList.contains('open')) {
      event.preventDefault();
      this.onOpen();
    }
  }
  onOpen() {
    if (!this.classList.contains('open')) {
      this.collectionSidebar.classList.add('open');
      document.documentElement.classList.add('open-drawer', 'open-sidebar');
      root.style.setProperty('padding-right', getScrollBarWidth.init() + 'px');
      this.classList.add('open');
      this.setAttribute('aria-expanded', 'true');
      this.syncAccessibilityState(true);
      this.collectionSidebar.addEventListener('keydown', this.onDrawerKeyDown);
      this.collectionSidebar.querySelector('close-filter')?.focus();
    } else {
      this.close();
    }
  }

  close() {
    this.collectionSidebar.classList.remove('open');
    document.documentElement.classList.remove('open-drawer', 'open-sidebar');
    root.style.removeProperty('padding-right');
    this.classList.remove('open');
    this.setAttribute('aria-expanded', 'false');
    this.collectionSidebar.removeEventListener('keydown', this.onDrawerKeyDown);
    this.syncAccessibilityState(false);
    this.focus({ preventScroll: true });
  }

  syncAccessibilityState(isOpen = this.classList.contains('open')) {
    const isDrawer = window.innerWidth <= 1024 || this.collectionSidebar.classList.contains('drawer');
    if (!isDrawer) {
      if (isOpen) {
        this.collectionSidebar.classList.remove('open');
        document.documentElement.classList.remove('open-drawer', 'open-sidebar');
        root.style.removeProperty('padding-right');
        this.classList.remove('open');
        this.setAttribute('aria-expanded', 'false');
        this.collectionSidebar.removeEventListener('keydown', this.onDrawerKeyDown);
      }
      this.collectionSidebar.removeAttribute('role');
      this.collectionSidebar.removeAttribute('aria-modal');
      this.collectionSidebar.removeAttribute('aria-hidden');
      this.collectionSidebar.removeAttribute('inert');
      return;
    }
    this.collectionSidebar.setAttribute('role', 'dialog');
    this.collectionSidebar.setAttribute('aria-modal', 'true');
    this.collectionSidebar.setAttribute('aria-hidden', String(!isOpen));
    this.collectionSidebar.toggleAttribute('inert', !isOpen);
  }

  handleDrawerKeyDown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...this.collectionSidebar.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [role="button"][tabindex="0"], [role="checkbox"][tabindex="0"]'
    )].filter((element) => {
      const style = getComputedStyle(element);
      return style.display !== 'none'
        && style.visibility !== 'hidden'
        && element.getClientRects().length > 0;
    });
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
}
customElements.define('btn-filter', BtnFilter);
class CloseFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById('CollectionSidebar');
    this.setAttribute('role', 'button');
    this.setAttribute('tabindex', '0');
    this.addEventListener('click', this.onClose.bind(this), false);
    this.addEventListener('keydown', this.onKeyDown.bind(this), false);
  }
  onKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Escape') {
      event.preventDefault();
      this.onClose();
    }
  }
  onClose() {
    const trigger = document.querySelector('btn-filter.open');
    if (trigger?.close) {
      trigger.close();
      return;
    }
    this.collectionSidebar.classList.remove('open');
    document.documentElement.classList.remove('open-drawer', 'open-sidebar');
    root.style.removeProperty('padding-right');
  }
}
customElements.define('close-filter', CloseFilter);

class FacetApplyCanvas extends HTMLElement {
  constructor() {
    super();
    this.setAttribute('role', 'button');
    this.setAttribute('tabindex', '0');
    this.addEventListener('click', this.applyFilters.bind(this), false);
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.applyFilters();
      }
    });
  }

  applyFilters() {
    const grid = document.querySelector(options_collection.productgridcontainer);
    document.querySelector('btn-filter.open')?.close();
    if (!grid) return;
    const header = document.querySelector('header[data-sticky]');
    const stickyEnabled = header && header.dataset.sticky !== 'none'
      && (window.innerWidth > 1024 || header.dataset.stickyMobile !== 'false');
    // A scroll-up header may be hidden now and reappear as we reach the results.
    const headerOffset = (stickyEnabled ? header.closest('.section-header')?.offsetHeight || 0 : 0) + 16;
    window.scrollTo({
      top: grid.getBoundingClientRect().top + window.pageYOffset - headerOffset,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }
}
customElements.define('facet-apply-canvas', FacetApplyCanvas);

class GridMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.gridMode.bind(this), false);
  }
  async gridMode() {
    if (this.classList.contains('active')) return;
    const view_mode = this.getAttribute('data-grid-mode');
    if (view_mode == 1) return;
  await motion.animate(
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ),
      {
        transform: ['translateY(0)', 'translateY(3.5rem)'],
        opacity: [1, 0.01],
        visibility: ['visible', 'hidden'],
      },
      {
        duration: 0.3,
        delay: motion.stagger(0.05),
        easing: [0, 0, 0.3, 1],
      }
    );


    for (var item of document.querySelectorAll('grid-mode')) {
      item.classList.remove('active');
    }
    const container_switch = document.querySelector(
      '.container-products-switch'
    );
    this.classList.add('active');
    const data_view_mode = container_switch.getAttribute('data-view-mode');
    container_switch.classList.remove('grid-columns-' + data_view_mode);
    container_switch.setAttribute('data-view-mode', view_mode);
    container_switch.classList.add('grid-columns-' + view_mode);
    motion.animate(
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ),
      {
        transform: ['translateY(3.5rem)', 'translateY(0)'],
        opacity: [0.01, 1],
        visibility: ['hidden', 'visible'],
      },
      {
        duration: 0.3,
        delay: motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    );
  }
}
customElements.define('grid-mode', GridMode);

class ViewMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.viewMode.bind(this), false);
  }
  viewMode() {
    const view_mode = this.getAttribute('data-view');
    if (this.classList.contains('actived')) return;
    eventCollectionShopify.changeParam('view', view_mode === 'list' ? 'list' : 'grid');
  }
}
customElements.define('view-mode', ViewMode);

class FilterItem extends HTMLElement {
  constructor() {
    super();
    const isChoice = Boolean(this.closest('.filter-content'));
    const isChecked = Boolean(
      this.closest('li.current-filter') || this.querySelector('.current-filter')
    );
    const isDisabled = this.classList.contains('option-disabled') || this.closest('li')?.classList.contains('disabled');
    this.setAttribute('role', isChoice ? 'checkbox' : 'button');
    this.setAttribute('tabindex', isDisabled ? '-1' : '0');
    this.setAttribute('aria-disabled', String(isDisabled));
    if (isChoice) this.setAttribute('aria-checked', String(isChecked));
    this.addEventListener('click', this.filterItem.bind(this), false);
    this.addEventListener('keydown', this.onKeyDown.bind(this), false);
  }
  onKeyDown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.filterItem();
    }
  }
  filterItem() {
    if (this.getAttribute('aria-disabled') === 'true') return;
    if (this.dataset.filterClearAll === 'true') {
      eventCollectionShopify.clearFilters();
      return;
    }
    if (this.getAttribute('role') === 'checkbox') {
      this.setAttribute('aria-checked', String(this.getAttribute('aria-checked') !== 'true'));
      this.closest('li')?.classList.toggle('current-filter');
      this.querySelector('.tooltip')?.classList.toggle('current-filter');
    }
    eventCollectionShopify.changeFilter(this);
  }
}
customElements.define('filter-item', FilterItem);

class FacetClearAll extends HTMLElement {
  constructor() {
    super();
    this.setAttribute('role', 'button');
    this.setAttribute('tabindex', '0');
    this.addEventListener('click', this.filterItem.bind(this), false);
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.filterItem();
      }
    });
  }
  filterItem() {
    eventCollectionShopify.clearFilters();
  }
}
customElements.define('facet-clear-all', FacetClearAll);

class FilterSort extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.filterSort.bind(this), false);
  }
  filterSort() {
    const value = this.getAttribute('value');
    eventCollectionShopify.changeParam('sort_by', value);
  }
}
customElements.define('filter-sort', FilterSort);

class CollectionSort extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.filterSort.bind(this), false);
  }

  filterSort(event) {
    if (!event.target.matches('.collection-sort__select')) return;

    eventCollectionShopify.changeParam('sort_by', event.target.value);
  }
}
customElements.define('collection-sort', CollectionSort);

class SelectSorter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.closest('.select-custom').classList.contains('active')) {
      this.closest('.select-custom').classList.remove('active');
    } else {
      this.closest('.select-custom').classList.add('active');
    }
  }
}
customElements.define('select-sorter', SelectSorter);

var eventCollectionShopify = (function () {
  return {
    activeRequestController: null,
    activeRequestId: 0,
    desiredParams: null,
    lastSuccessfulParams: null,

    init: function () {
      this.desiredParams = this.paramsFromLocation();
      this.lastSuccessfulParams = new URLSearchParams(this.desiredParams);
      this.ionRangeSlider();
      if (!this.popstateHandler) {
        this.popstateHandler = () => {
          this.desiredParams = this.paramsFromLocation();
          this.syncPendingFilterState();
          this.renderForDesiredParams({
            updateHistory: false,
            scrollToGrid: false,
          });
        };
        window.addEventListener('popstate', this.popstateHandler);
      }
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const horizontal = document.querySelector('.horizontal-filter');
        if (horizontal) {
          const collapsible = document.querySelectorAll('collapsible-block');
          collapsible.forEach((e) => {
            e.classList.add('active');
          });
        }
      }
    },

    ionRangeSlider: function () {
      const price_range = document.querySelector('.price-range');
      const maxRange = document.querySelector(
        options_collection.rangeSliderMax
      );
      const minRange = document.querySelector(
        options_collection.rangeSliderMin
      );
      const minPrice = document.querySelector('.min-price-range');
      const maxPrice = document.querySelector('.max-price-range');
      var minPriceRange = 0;
      var maxPriceRange = 0;
      if (!price_range || price_range.dataset.filterRangeReady === 'true') return;
      price_range.dataset.filterRangeReady = 'true';
      const submitPriceRange = () => {
        const form = document.querySelector(options_collection.collectionFiltersForm);
        if (!form) return;
        const formData = new FormData(form);
        const nameMin = minPrice.getAttribute('name');
        const nameMax = maxPrice.getAttribute('name');
        this.desiredParams.delete(nameMin);
        this.desiredParams.delete(nameMax);
        const minValue = formData.get(nameMin);
        const maxValue = formData.get(nameMax);
        if (minValue) this.desiredParams.append(nameMin, minValue);
        if (maxValue) this.desiredParams.append(nameMax, maxValue);
        this.desiredParams.delete('page');
        this.syncPendingFilterState();
        this.renderForDesiredParams();
      };
      document.querySelector(options_collection.minPriceRange).addEventListener(
        'change',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          target.value = target.value.replace(',', '');
          if (Number(minRange.min) + Number(target.value) >= 0) {
            if (Number(target.value) > Number(maxRange.max)) {
              minPrice.value = Number(maxRange.max);
            } else {
              minPrice.value = Number(target.value);
            }
          } else {
            minPrice.value = Number(minRange.min);
          }
          submitPriceRange();
        },
        false
      );
      document.querySelector(options_collection.maxPriceRange).addEventListener(
        'change',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          target.value = target.value.replace(',', '');
          if (Number(maxRange.max) - Number(target.value) >= 0) {
            maxPrice.value = Number(target.value);
          } else {
            maxPrice.value = Number(maxRange.max);
          }
          submitPriceRange();
        },
        false
      );
      document
        .querySelector(options_collection.rangeSliderMin)
        .addEventListener(
          'input',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (Number(maxRange.value) - Number(target.value) >= 1) {
              minPrice.value = Number(target.value);
              minPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(maxRange.value) - 1;
              minPriceRange = (Number(maxRange.value) - 1) * 100;
            }
            const price_format = Shopify.formatMoney(
              minPriceRange,
              cartStrings.money_format
            );
            document.querySelector('.price-lable .min').innerHTML =
              price_format;
            target
              .closest('.price-range')
              .style.setProperty(
                '--range-from',
                (minRange.value / Number(target.getAttribute('max'))) * 100 +
                  '%'
              );
          },
          false
        );
      document
        .querySelector(options_collection.rangeSliderMax)
        .addEventListener(
          'input',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (target.value - minRange.value >= 1) {
              maxPrice.value = target.value;
              maxPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(minRange.value) + Number(1);
              maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
            }
            const price_format = Shopify.formatMoney(
              maxPriceRange,
              cartStrings.money_format
            );
            document.querySelector('.price-lable .max').innerHTML =
              price_format;
            target
              .closest('.price-range')
              .style.setProperty(
                '--range-to',
                (maxRange.value / Number(target.getAttribute('max'))) * 100 +
                  '%'
              );
          },
          false
        );
      document
        .querySelectorAll(options_collection.rangeSlider)
        .forEach((sliderRange) => {
          sliderRange.addEventListener(
            'change',
            (event) => {
              event.preventDefault();
              const target = event.currentTarget;
              submitPriceRange();
            },
            false
          );
        });
    },

    paramsFromLocation: function () {
      const params = new URLSearchParams(window.location.search);
      params.delete('section_id');
      return params;
    },

    renderUrl: function (searchParams) {
      const sectionId = document.querySelector(options_collection.section)
        .dataset.sectionId;
      const params = new URLSearchParams(searchParams);
      params.set('section_id', sectionId);
      const url = `${window.location.pathname}?${params.toString()}`;
      return url;
    },

    changeParam: function (name, value) {
      this.desiredParams.set(name, value);
      this.desiredParams.delete('page');
      this.renderForDesiredParams();
    },

    changeFilter: function (element) {
      const name = element.dataset.filterParam;
      const value = element.dataset.filterValue;
      if (!name) {
        this.setDesiredParamsFromHref(element.dataset.href);
      } else if (element.dataset.filterClear === 'true') {
        this.desiredParams.delete(name);
        if (element.dataset.filterClearParam) this.desiredParams.delete(element.dataset.filterClearParam);
      } else {
        const values = this.desiredParams.getAll(name);
        if (element.dataset.filterRemove === 'true') {
          this.desiredParams.delete(name);
          values.filter((current) => current !== value).forEach((current) => this.desiredParams.append(name, current));
        } else if (values.includes(value)) {
          this.desiredParams.delete(name);
          values.filter((current) => current !== value).forEach((current) => this.desiredParams.append(name, current));
        } else {
          this.desiredParams.append(name, value);
        }
      }
      this.desiredParams.delete('page');
      this.syncPendingFilterState();
      this.renderForDesiredParams();
    },

    setDesiredParamsFromHref: function (href) {
      if (!href) return;
      const next = new URL(href, window.location.origin).searchParams;
      const preserve = ['q', 'type', 'options[prefix]', 'sort_by'];
      preserve.forEach((name) => {
        if (!next.has(name) && this.desiredParams.has(name)) {
          this.desiredParams.getAll(name).forEach((value) => next.append(name, value));
        }
      });
      next.delete('section_id');
      next.delete('page');
      this.desiredParams = new URLSearchParams(next);
    },

    clearFilters: function () {
      [...this.desiredParams.keys()].forEach((name) => {
        if (name.startsWith('filter.')) this.desiredParams.delete(name);
      });
      this.desiredParams.delete('page');
      this.syncPendingFilterState();
      this.renderForDesiredParams();
    },

    syncPendingFilterState: function () {
      document.querySelectorAll('#CollectionFiltersForm input[name]').forEach((input) => {
        input.value = this.desiredParams.get(input.name) || '';
      });
      ['min', 'max'].forEach((bound) => {
        const input = document.querySelector(`.${bound}-price-range`);
        const slider = document.querySelector(`.range-slider-${bound}`);
        if (!input || !slider) return;
        slider.value = input.value || slider.getAttribute(bound);
        slider.closest('.price-range')?.style.setProperty(
          bound === 'min' ? '--range-from' : '--range-to',
          `${Number(slider.value) / Number(slider.max) * 100}%`
        );
        const label = document.querySelector(`.price-lable .${bound}`);
        if (label) label.innerHTML = Shopify.formatMoney(Number(slider.value) * 100, cartStrings.money_format);
      });
      document.querySelectorAll('filter-item[data-filter-param][data-filter-value]').forEach((item) => {
        const selected = this.desiredParams.getAll(item.dataset.filterParam).includes(item.dataset.filterValue);
        if (item.getAttribute('role') === 'checkbox') item.setAttribute('aria-checked', String(selected));
        item.closest('li')?.classList.toggle('current-filter', selected);
        item.querySelector('.tooltip')?.classList.toggle('current-filter', selected);
        if (item.dataset.filterRemove === 'true') item.hidden = !selected;
      });
    },

    renderForDesiredParams: function (renderOptions = {}) {
      this.renderSectionFilter(this.renderUrl(this.desiredParams), this.desiredParams, renderOptions);
    },

    renderSectionFilter: function (url, searchParams, renderOptions = {}) {
      const requestedParams = new URLSearchParams(searchParams || this.desiredParams);
      const requestId = ++this.activeRequestId;
      this.activeRequestController?.abort();
      this.activeRequestController = new AbortController();
      const { signal } = this.activeRequestController;
      this.toggleLoading(document.body, true);
      this.setFilterStatus('loading');
      fetch(`${url}`, { signal })
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((responseText) => {
          if (requestId !== this.activeRequestId) return;
          const parsed = new DOMParser().parseFromString(responseText, 'text/html');
          this.replaceFilterBlocks(parsed);
          if (renderOptions.updateHistory !== false) this.updateUrl(requestedParams);
          this.replaceProductGrid(parsed);
          this.lastSuccessfulParams = new URLSearchParams(requestedParams);
          this.setFilterStatus('success', parsed);
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          console.error('Unable to update collection results.', error);
          if (requestId === this.activeRequestId) this.setFilterStatus('error');
        })
        .finally(() => {
          if (requestId !== this.activeRequestId) return;
          this.toggleLoading(document.body, false);
          document.querySelector('grid-list')?.showGridItems();
          initLazyloadItem();
          BlsLazyloadImg.init();
          eventCollectionShopify.ionRangeSlider();
          this.activeRequestController = null;
        });
    },

    replaceFilterBlocks: function (parsed) {
      const current = document.querySelector(options_collection.collectionFilterBlocks);
      const next = parsed.querySelector(options_collection.collectionFilterBlocks);
      if (!current || !next) return;
      const sidebar = current.closest('#CollectionSidebar');
      const blocksScrollTop = current.scrollTop;
      const scrollTop = sidebar?.querySelector('.collection-sidebar')?.scrollTop;
      const active = document.activeElement;
      const focusWasInFilters = current.contains(active);
      const activeGroupKey = active?.closest?.('[data-filter-group-key]')?.dataset.filterGroupKey;
      const key = active?.dataset?.filterKey;
      const activeId = active?.id;
      const groupStates = [...current.querySelectorAll('collapsible-block[data-filter-group-key]')]
        .map((group) => [group.dataset.filterGroupKey, group.classList.contains('active')]);
      const contentScroll = [...current.querySelectorAll('[data-filter-group-key]')]
        .map((group) => [group.dataset.filterGroupKey, [...group.querySelectorAll('.filter-content, .collapsible-content > *')]
          .map((content) => content.scrollTop)]);
      current.innerHTML = next.innerHTML;
      groupStates.forEach(([groupKey, isOpen]) => {
        const group = current.querySelector(`[data-filter-group-key="${CSS.escape(groupKey)}"]`);
        if (!group) return;
        group.classList.toggle('active', isOpen);
        group.querySelector('.collapsible-heading')?.setAttribute('aria-expanded', String(isOpen));
        const content = group.querySelector('.collapsible-content');
        if (content) content.style.display = isOpen ? 'block' : 'none';
      });
      contentScroll.forEach(([groupKey, positions]) => {
        const group = current.querySelector(`[data-filter-group-key="${CSS.escape(groupKey)}"]`);
        group?.querySelectorAll('.filter-content, .collapsible-content > *').forEach((content, index) => {
          content.scrollTop = positions[index] || 0;
        });
      });
      if (typeof scrollTop === 'number') sidebar.querySelector('.collection-sidebar').scrollTop = scrollTop;
      current.scrollTop = blocksScrollTop;
      if (focusWasInFilters && document.activeElement === document.body) {
        const replacement = (key && current.querySelector(`[data-filter-key="${CSS.escape(key)}"]`))
          || (activeId && current.querySelector(`#${CSS.escape(activeId)}`))
          || (activeGroupKey && current.querySelector(`[data-filter-group-key="${CSS.escape(activeGroupKey)}"] .collapsible-heading`));
        replacement?.focus({ preventScroll: true });
      }
    },

    replaceProductGrid: function (parsed) {
      const current = document.querySelector(options_collection.productgridcontainer);
      const next = parsed.querySelector(options_collection.productgridcontainer);
      if (!current || !next) return;
      const currentProducts = current.querySelector('.product-grid-container');
      const nextProducts = next.querySelector('.product-grid-container');
      if (currentProducts && nextProducts) currentProducts.innerHTML = nextProducts.innerHTML;
      const currentRelated = current.querySelector('search-related-collections');
      const nextRelated = next.querySelector('search-related-collections');
      currentRelated?.remove();
      if (nextRelated) currentProducts?.after(nextRelated.cloneNode(true));
      const currentFilters = current.querySelector('.filter-current');
      const nextFilters = next.querySelector('.filter-current');
      if (currentFilters && nextFilters) currentFilters.innerHTML = nextFilters.innerHTML;
      if (currentFilters && !nextFilters) currentFilters.remove();
      if (!currentFilters && nextFilters) current.querySelector('.toolbar-products')?.after(nextFilters.cloneNode(true));
      const currentSort = current.querySelector('.collection-sort__select');
      const nextSort = next.querySelector('.collection-sort__select');
      if (currentSort && nextSort) currentSort.value = nextSort.value;
      const currentAmount = current.querySelector('#toolbar-amount');
      const nextAmount = next.querySelector('#toolbar-amount');
      if (currentAmount && nextAmount) currentAmount.innerHTML = nextAmount.innerHTML;
      const currentView = current.querySelector('.show-type-products');
      const nextView = next.querySelector('.show-type-products');
      if (currentView && nextView) currentView.innerHTML = nextView.innerHTML;
      const currentHeading = document.querySelector('.search-page-heading');
      const nextHeading = parsed.querySelector('.search-page-heading');
      if (currentHeading && nextHeading) currentHeading.innerHTML = nextHeading.innerHTML;
    },

    setFilterStatus: function (state, parsed) {
      document.querySelector('.product-grid-container')?.setAttribute('aria-busy', String(state === 'loading'));
      const text = state === 'loading'
        ? document.querySelector('#CollectionSidebar')?.dataset.loadingText
        : state === 'error'
          ? document.querySelector('#CollectionSidebar')?.dataset.errorText
          : '';
      this.resultFeedback();
      document.querySelector('#CollectionSidebar .filter-feedback')?.toggleAttribute('hidden', !text);
      document.querySelectorAll('[data-filter-status]').forEach((status) => {
        status.hidden = !text;
        status.textContent = text || '';
        status.classList.toggle('is-error', state === 'error');
      });
      document.querySelectorAll('facet-apply-canvas [data-filter-apply-label]').forEach((label) => {
        const sidebar = label.closest('#CollectionSidebar');
        const count = parsed?.querySelector('#CollectionSidebar')?.dataset.resultCount || sidebar?.dataset.resultCount;
        if (state === 'success' && count) sidebar.dataset.resultCount = count;
        label.textContent = state === 'loading'
          ? sidebar?.dataset.applyPendingText
          : state === 'error'
            ? sidebar?.dataset.applyPendingText
            : this.applyLabel(sidebar, count);
      });
      document.querySelectorAll('[data-filter-retry]').forEach((button) => {
        button.hidden = state !== 'error';
        button.textContent = document.querySelector('#CollectionSidebar')?.dataset.retryText || button.textContent;
        button.onclick = () => this.renderForDesiredParams();
      });
    },

    resultFeedback: function () {
      const container = document.querySelector(options_collection.productgridcontainer);
      if (!container || container.querySelector('[data-filter-results-feedback]')) return;
      const feedback = document.createElement('div');
      feedback.className = 'filter-results-feedback mb-15';
      feedback.dataset.filterResultsFeedback = '';
      feedback.setAttribute('aria-live', 'polite');
      feedback.innerHTML = '<span data-filter-status hidden></span><button type="button" class="btn-reset btn-link" data-filter-retry hidden></button>';
      const grid = container.querySelector('.product-grid-container');
      grid?.before(feedback);
    },

    applyLabel: function (sidebar, count) {
      const template = Number(count) === 1 ? sidebar?.dataset.applyOneText : sidebar?.dataset.applyText;
      return (template || '').replace('__count__', count || '0');
    },

    toggleLoading: function (event, loading) {
      if (event) {
        if (loading) {
          event.classList.add('start', 'loading');
        } else {
          event.classList.add('finish');
          setTimeout(function () {
            event.classList.remove('start', 'loading', 'finish');
          }, 500);
        }
      }
    },

    updateUrl: function (searchParams) {
      const query = new URLSearchParams(searchParams).toString();
      const url = `${window.location.pathname}${query ? `?${query}` : ''}`;
      if (window.location.pathname + window.location.search !== url) window.history.pushState({ url }, '', url);
    },
  };
})();
eventCollectionShopify.init();
